import exclamationIcon from 'src/icons/exclamation.svg';
import SearchIcon from 'src/icons/search';

const SearchInput = ({
    type,
    value,
    setValue,
    label,
    fieldName,
    placeholder,
    error,
    className,
    inputClassName = '',
    displayButton = false,
    onSearchClick,
}) => {
    return (
        <label htmlFor={fieldName} className={`flex flex-col text-sm mb-4 w-full ${className ?? ''}`}>
            {label}
            <div
                className={
                    `flex justify-between border ${
                        error ? 'border-red' : 'border-gray-light'
                    } bg-gray-light rounded-xl focus:ring-orange focus:border-orange ${
                        displayButton ? 'pl-0' : 'pl-4'
                    } mt-2 overflow-hidden ` +
                    (inputClassName + '')
                }
            >
                {!displayButton && <SearchIcon className="h-11" />}
                <input
                    type={type ?? 'text'}
                    name={fieldName}
                    id={fieldName}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={placeholder ?? label}
                    required
                    className="block text-sm border py-3 px-5 outline-none w-full border-0 bg-gray-light rounded-xl"
                />
                {displayButton && (
                    <button
                        className="h-11 w-14 text-white bg-gradient-to-r from-orange to-pink flex items-center justify-center"
                        onClick={onSearchClick}
                        type="button"
                    >
                        <SearchIcon color="#ffffff" />
                    </button>
                )}
            </div>
            {error && (
                <span className="text-red flex items-center text-xs">
                    <img src={exclamationIcon} alt={'exclamation point'} /> {error}
                </span>
            )}
        </label>
    );
};

export default SearchInput;
